import { TippingCore } from '../../../../core/models';

export default class Tipping extends TippingCore {
	defaults(){
		return {
			overall_rank: 0,
			total_points: 0,
			total_margin: 0,
			total_ranked_users: 0,
			round_points: 0,
			selected_tips_count: 0,
			total_tips_count: 0,
		}
	}
}